<div class="data-table-container">
    <div class="data-table-title">
        <h1>{{ "EXPERT.TABLEHEADER" | translate}}</h1>
        <!--<div>
            <button mat-raised-button color="primary" class="did-config-button" routerLink="/dataidentifier-config">
                <mat-icon>perm_data_setting</mat-icon>
                <span class="button-item-label">Data Configuration</span>
            </button>
        </div>-->
    </div>
    <!--<div class="table-filter">
        <mat-form-field>
            <mat-label>Search for DID or Timestamp</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="'258' or '13:05'" #input />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>-->

    <table mat-table [dataSource]="dataSet" matSort class="example-table">
        <!-- ECU ID Column -->
        <ng-container matColumnDef="ecu_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by DID">{{ "EXPERT.TABLE.ECU_ID" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.identifier.ecu_id }}</td>
        </ng-container>

        <!-- Data ID Column -->
        <ng-container matColumnDef="data_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by DID">{{ "EXPERT.TABLE.DATA_ID" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.identifier.data_id }}</td>
        </ng-container>

        <!-- Timestamp Column -->
        <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Time">{{ "EXPERT.TABLE.TIMESTAMP" | translate}}</th>
            <td mat-cell *matCellDef="let row">
                {{ row.data.timestamp != -1 ? (row.data.timestamp - 3600000 | date : "HH:mm:ss.SSS") : '-' }}
                <!--Substract 1 hour because of time zoning-->
            </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>{{ "EXPERT.TABLE.VALUE" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.data.timestamp != -1 ? row.data.value : '-' }}</td>
        </ng-container>

        <!-- Table Extension -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            (click)="this.router.navigate(['dataDisplay/detail/id', row.identifier.ecu_id, row.identifier.data_id])"
            *matRowDef="let row; columns: displayedColumns"
        ></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">
                <div class="no-data" [innerHTML]="'EXPERT.SUGGESTION' | translate">
                </div>
            </td>
        </tr>
    </table>
</div>
